import { Controller } from "@hotwired/stimulus"

// Inserts a {{platzhalter}} token into the Textbaustein content textarea at the
// cursor. Goes through execCommand("insertText") so the browser's undo stack
// (Ctrl/Cmd+Z) keeps working; falls back to setRangeText where unsupported.
export default class extends Controller {
  static targets = ["textarea"]

  insert(event) {
    const token = event.currentTarget.dataset.token
    const textarea = this.textareaTarget
    textarea.focus()
    if (!document.execCommand("insertText", false, token)) {
      textarea.setRangeText(token, textarea.selectionStart, textarea.selectionEnd, "end")
      textarea.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }
}
